import { render, staticRenderFns } from "./ErpResponsePopup.vue?vue&type=template&id=22b8febd&scoped=true"
import script from "./ErpResponsePopup.vue?vue&type=script&lang=js"
export * from "./ErpResponsePopup.vue?vue&type=script&lang=js"
import style0 from "./ErpResponsePopup.vue?vue&type=style&index=0&id=22b8febd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8febd",
  null
  
)

export default component.exports